<template>
  <div id="home">
    <Top
      :languageList="languageList"
      :books="books"
      :paragraphs="paragraphs"
      :minutes="minutes"
      :languages="languageCount"
    />
    <ModesSection />
    <MotivationSection />
    <TeachersSection />
    <PaymentSection />
    <Comments />
    <PaymentSection />
  </div>
</template>

<script>
import Top from "../components/Home/Top";
import Comments from "../components/Home/Comments";
import TeachersSection from "../components/Home/TeachersSection";
import ModesSection from "../components/Home/ModesSection";
import MotivationSection from "../components/Home/MotivationSection";
import PaymentSection from "../components/Home/PaymentSection";
import dataService from "../services/dataService";
export default {
  name: "Home",
  components: {
    Top,
    Comments,
    TeachersSection,
    ModesSection,
    MotivationSection,
    PaymentSection
  },
  computed: {
    books() {
      return this.stats ? this.stats.books : "...";
    },
    paragraphs() {
      return this.stats ? this.stats.sections : "...";
    },
    minutes() {
      return this.stats ? this.stats.minutes : "...";
    },
    languageCount() {
      return this.stats ? this.stats.languages.length : "...";
    },
    languageList() {
      return this.stats ? this.stats.languages.join(", ") : "...";
    }
  },
  data() {
    return {
      stats: undefined
    };
  },
  async created() {
    if (this.stats === undefined) {
      this.stats = await dataService.getHomePageStats();
    }
  }
};
</script>

<style lang="scss" scoped>
#home {
  font-family: "Montserrat", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
